import React, { Component } from 'react';

import Page from '../components/Page';
import { Accordion, PanelGroup } from '../components/Accordion';
import { TabHolder, Tab } from '../components/Tabs';

export default class FAQs extends Component{
    
	render(){

		const menuItems = [
			{ id: "general", name: "General", active: true },
			{ id: "policies", name: "Policies" },
			{ id: "users", name: "Users" },
			{ id: "insurance", name: "Insurance"}
		]

		return(
			<Page pageTitle="Frequently Asked Questions (FAQs)">

				<TabHolder menuItems={ menuItems }>
					<Tab menuId={ menuItems[0].id } isActive={ true }>
						
						<Accordion className="col-md-9">
						<PanelGroup
								title="What is Tanzania Imports Insurance Portal?"
								show={ true }>

								<p>
									The Tanzania Institute of Insurers Marine Cargo Insurance Portal, TIIP, 
									is Tanzania's official Imports/Exports Insurance marketplace that enables 
									Tanzanian importers and exporters, their Brokers and Trading Partners overseas, 
									to purchase Marine Cargo Insurance in minutes, at any time of night and day, 
									anywhere in the world.  
								</p>
							</PanelGroup>
							<PanelGroup
								title="Why Tanzania Imports Insurance Portal?">
								<p>
								Tanzania Imports Insurance Portal,TIIP,was created to ensure not only safeguarding of the Clients’ goods but also with the macro effect to the Tanzanian economy by reducing exportation of currency/ premium which can be retained locally. 
								In addition to the same,TIIP ensures that clients that import goods into Tanzania are assisted with their claims, if any,
								with utmost speed and diligence by the Locally registered Insurance players. 
								Lastly, the retention of premium and opportunity created for additional distribution channels (through Insurance Intermediaries) will without doubt give more employment opportunities to local Tanzanians. 
								</p>
							</PanelGroup>
							
							<PanelGroup title="What is Tanzania Imports Insurance Portal?">
								<p>
									The Tanzania Institute of Insurers Marine Cargo Insurance Portal, TIIP, 
									is Tanzania's official Imports/Exports Insurance marketplace that enables Tanzanian importers and exporters, 
									their Brokers and Trading Partners overseas, to purchase Marine Cargo Insurance in minutes, 
									at any time of night and day, anywhere in the world.  
								</p>
								<p>
									The TIIP automates the process of underwriting the marine risk for your goods from the 
									foreign warehouse or port all the way to your inland destination. 
								</p>
							</PanelGroup>

							<PanelGroup title="Why a national insurance platform?">
								<p>
									Section 133 of The Insurance Act was amended in 2017 to clarify that all imports by Tanzania Citizens and 
									Tanzanian Legal Persons/Companies, whether by Road, Rail, Sea or Air, 
									must be insured by Insurance companies registered in Tanzania. 
								</p>
								<p>
									It was proposed to effect these amendments with full effect from 1st January 2018. 
									To ensure that this deadline is met, TIRA proposed to have a Imports/Exports Insurance 
									Platform that would deliver on the expected results. 
								</p>
							</PanelGroup>

							<PanelGroup title="What does the Platform offer?">
								<ul className="infolist">
									<li>
										<strong>Instant Imports/Exports Insurance Cover:</strong> The insurance cover obtained 
										on the platform is effective immediately payment is made and confirmed.
									</li>
									<li>
										<strong>Multiple Consignment capabilities:</strong> The platform is able to support 
										multiple shipments (e.g. grain, vehicles, pharmaceuticals) that are booked on the 
										same shipping vessel.
									</li>
									<li>
										<strong>Universal accessibility:</strong> The platform can be accessed online from 
										a desktop computer or from a mobile device at any time, from anywhere in the world. 
									</li>
									<li>
										<strong>Authentic, Secure Insurance Certificates:</strong> The Marine Cargo Insurance 
										Certificates produced on the platform are auditable and verifiable. The certificates 
										contain a number of security features including a valid Policy Number from your insurer, 
										a Unique Reference Number and a scannable Quick Reference (QR) code. This security feature 
										makes it extremely difficult to forge or reproduce the certificates issued on the Portal.
									</li>
								</ul>
							</PanelGroup>
								

							<PanelGroup title="Who can use the platform?">
								<p>
									<strong><em>Practically anyone involved in the logistics and import business, from importers to their 
									suppliers, clearing agents, freight forwarders, insurance intermediaries and the insurers 
									themselves.</em></strong>
								</p>
								<p>
									As an importer, you can use the platform directly or have your insurance agent or broker 
									purchase insurance on your behalf. 
								</p>
								<p>
									The Quick Quote feature allows  you as the Client, your Broker/Agent or even your trading partner 
									abroad, to obtain and relay quotations for marine insurance in minutes, enabling all concerned 
									to plan appropriately. 
								</p>
							</PanelGroup>

							<PanelGroup title="What goods are covered by the Insurance Products?">
								<p>
									All goods and commodities allowed into the country, 
									over 5,500 specific types of goods are insurable but you will find that different insurers have 
									different restrictions on the type of goods they can insure. 
									These goods are represented by 22 specific categories on the portal.
								</p>
								<p>
									Currently the Portal accommodates all importable goods listed out on the Tanzania Revenue Authority’s 
									East African Community Common Tariff Handbook. 
									However, some categories are subject to underwriter and insurance industry business rules and regulations. 
									If in doubt, please seek more information from your insurance broker or insurer contact person.
								</p>
							</PanelGroup>
							
							<PanelGroup title="What payment methods does the platform accommodate?">
								<p>
									All forms of traditional, mobile and funds transfer modes of payment.
								</p>
								<p>
									The Portal’s payments interface allows users to pay premiums using a variety of payment methods including 
									Mobile Money (MPesa, Airtel Money, Tigo, MTN), Bank Transfers on TT, EFT and RTGS, 
									as well as credit cards including Visa and MasterCard.
								</p>
							</PanelGroup>
							
							<PanelGroup title="How long does it take for my payment to clear and for my Marine Cargo Insurance Certificate to be available?">
								<p>
									For Mobile Money payments as well as credit card payments, 
									receipt of payment is acknowledged instantaneously and the certificate can be obtained as soon as payment confirmation is received 
									and entered into the payment solution interface.
								</p>
								<p>
									For RTGS, turnaround time is usually within half an hour while for Telegraphic Transfers and Electronic Funds Transfers, 
									payment confirmation and certificate availability is highly dependent on your bank’s arrangements but should take no longer 
									than 48 hours from the time your authorize the payment transaction.
								</p>
							</PanelGroup>

							<PanelGroup title="What about insurance clients that already have existing credit facilities?">
								<p>
									Clients can charge marine cargo insurance premiums against existing credit facilities with their 
									insurers, against what is also commonly referred to as Open Cover Arrangements. The platform allows 
									for credit/large clients to buy insurance against their credit facilities. The agreed upon credit 
									terms apply.
								</p>
							</PanelGroup>

							<PanelGroup title="What supporting documents do I require in order to purchase my Marine Cargo Insurance Certificate?">
								<p>
									Although it helps to have soft copies of the following documents, only the Proof of payment is a mandatory document at the moment:
								</p>
								<ol className="numlist">
									<li><strong>Proof of payment: <em>Commercial Invoice, Quotation, Receipt</em></strong></li>
									<li>Bill of Lading or Airway Bill</li>
									<li>Packing List</li>
									<li>Import Declaration Form (IDF)</li>
								</ol>
								<p>
									The documents can be submitted in any of a wide range of formats including Portable Document Format 
									(PDF), Images (JPEG, PNG, BMP), Microsoft Word Document or other digital and clearly discernible/readable format.
								</p>
							</PanelGroup>

							<PanelGroup title="How can I see a history of my past purchases for record-keeping and accounting purposes?">
								<p>
									The Portal’s Activity Dashboards track all Marine Cargo Insurance transactions and quotes obtained on the Portal. 
									The dashboard provides details of Type and Value of Goods Insured, Port of Origin and Destination Date Insured, and Premiums paid. 
									The Portal also retains a copy of the Marine Cargo Insurance Certificate for future reference.  
								</p>
							</PanelGroup>

							<PanelGroup title="Is my data safe on the platform?">
								<p>Absolutely.</p>
								<p>
									TIIP utilizes a Cloud Services Provider that considers user and data security to be of the highest priority. 
									As a client, you will benefit from a data center and network architecture built to meet the requirements of the most 
									security-sensitive organizations including financial institutions, 
									government agencies and healthcare providers.  
								</p>
								<p>
									Whether at rest or in transit, your documents, data and transactions are handled, 
									transmitted and stored using state of the art encryption and security architecture.
								</p>
								<p>
									Maintaining customer trust is an ongoing commitment and we strive to inform customers of the privacy and data security policies, 
									practices and technologies that we put in place and continue to upgrade. 
								</p>
							</PanelGroup>

							<PanelGroup title="Do I need to install the software on my computer or mobile device?">
								<p>
									No. You need not worry about software installation or upgrades. 
									All updates are undertaken directly onto the web Portal ensuring that you have the most up to date version of the Portal at all times.
								</p>
								<p>
									TIIP does not require any software installations or upgrades. 
									Much like with any transaction platform, this also means that at any one time, you are transacting on the most up to date, 
									most secure version of the Portal.
								</p>
							</PanelGroup>

							<PanelGroup title="Can the TIIP be used on any browser?">
								<p>
									Certainly. However, it is advisable to install the latest version of Mozilla Firefox, Google Chrome, Safari, Vivaldi, 
									Brave and Internet Explorer 8 or above for a satisfactory experience.e.
								</p>
							</PanelGroup>

							<PanelGroup title="Can I submit a claim on TIIP?">
								<p>
									Sure. You can submit a claim using the portal’s claim submission interface. 
									The submission is received, reviewed and one of our agents will get in touch with you to walk you through 
									the claims process at the earliest possible opportunity.
								</p>
							</PanelGroup>
						</Accordion>
					</Tab>

					<Tab menuId={ menuItems[1].id }>
						
						<Accordion className="col-md-9">
							<PanelGroup 
								title={ `We have annual open marine cover, where client has paid a deposit 
									based on annual premium, How to proceed on the portal?  Will insurers 
									upload the deposit paid? – renewal not yet due, but client submitting declarations.` }
								show={ true }>

								<p>
									The Insurer will allocate a ‘user login’ either for the client to use themselves or 
									for you (AON) as their Broker to issue all their declarations upon. Our suggestion 
									would be for the client to use this from their own side as a self-service portal so 
									that they can acquire certificates at their convenience. The rates and terms would 
									be negotiated by AON in advance so that the covers issued would be in accordance to the same.
								</p>
								
							</PanelGroup>

							<PanelGroup title="Annual open cover where client has paid full annual policy in advance based on estimated annual & limit per transit.">
								<p>
									Renewal not yet due. No confirmations of insurance/certificate are being issued and 
									declaration would be done at the year end when an adjustment is being made
								</p>
								<p>
									Declarations will now have to be made as and when Cargo is arriving and not at the end of the 
									year as each Cargo will be having its own certificate from the Portal. This will assist in Data 
									Collection and at the same time curbs under-declaration (if any).
								</p>
							</PanelGroup>

							<PanelGroup title={
								`Is it not possible for the insurers to issue one marine open cover policy renewable 
								and paid annually where all consignments are covered. The policy is submitted to TRA 
								with confirmation that premium is paid and this annual cover is loaded onto TIIP site 
								and there would be no need to issue the certificates? This is mainly for corporate clients.`}>
								
								<p>
									Unfortunately this will defeat the purpose of Data Collection and is very much open to under-declaration. 
									Certificates are the key information to ensure that data collected at Customs TRA is cross-verified by 
									the Insurance certificates. Insurance will now be playing a key role in a number of data collection processes.
								</p>
							</PanelGroup>

							<PanelGroup title={
								`One off cover, where for the same type consignment, insurers have agreed rate.  Will insurers use 
								same rate going forward? How do we ensure this happens?`}>
								
								<p>
									With every corporate client having a one off cover, can we agree prior hand with the insurers the rate to be 
									charged? Then this rate Is uploaded on the TIIP website and every time the client requires a certificate, 
									the agreed rate is charged?
								</p>
								<p>
									Only walk-in rates (walk-in into the TIIP) are set but all other rates are determined between the Underwriter 
									and their Broker. Thus, you can charge as per your agreement and the upload requirement does NOT have any 
									rate requirement, thus negotiations would be open between Broker and Underwriter
								</p>
							</PanelGroup>

							<PanelGroup title="Do we also need to have insurers load marine stock through policies?">
								<p>Yes, All Marine covers/policies must be uploaded onto the portal.</p>
							</PanelGroup>
						</Accordion>
					</Tab>

					<Tab menuId={ menuItems[2].id }>
						
						<Accordion className="col-md-9">
							<PanelGroup 
								title="I just made my premium payment but my certificate did not print. What should I do?"
								show={ true }>

								<p>
									The most common cause for this issue is pop-up blockers stopping the opening of a new tab that will display the certificate. 
									Ensure that you allow pop-ups from our website and all should be fine.
								</p>
								<p>
									Further, ensure that you have the latest version of Adobe Acrobat Reader and that all updates have been installed.
								</p>
								<p>
									If you still encounter problems, kindly report the issue through our <strong>Online Issue Reporting tool 
									or call our helpline on +255 PLS HELP ME.</strong>
								</p>
							</PanelGroup>
							
							<PanelGroup 
								title="I just noticed an error in the Imports/Exports Insurance Certificate that I obtained? Is it still valid? What should I do to rectify the error?">

								<p>
									Get in touch with the underwriter via their contact details provided on the certificate and they will rectify 
									the issue at the earliest opportunity.
								</p>
							</PanelGroup>

							<PanelGroup title="I am unable register as a new user on the platform. What could be the problem?">
								<ol className="numlist">
									<li>Check to ensure that all fields have been completed</li>
									<li>
									Ensure that your Tanzania Revenue Authority (TRA) PIN are in the correct format i.e. ###-###-###. 
									Ensure that your email address is complete. If the problem persists, 
									Report the problem and it will be attended to immediately.
									</li>
								</ol>
							</PanelGroup>

							<PanelGroup title="Why should I insure locally?">
								<ul className="infolist">
									<li>To comply with Section 133 of The Amended Tanzania Insurance Act.</li>
									<li>To be sure that you have real Imports/Exports Insurance, with a real Imports/Exports Insurance Policy 
										and a real Imports/Exports Insurance Certificate</li>
									<li>To have the freedom and the opportunity to choose the best insurance cover for your needs, e.g. 
									from the foreign Port to your warehouse anywhere in the country.</li>
									<li>To have the opportunity to negotiate your preferred Insurance Cover rates and extent of cover</li>
									<li>To support the growth of the Tanzania’s Insurance Industry</li>
									<li>For ease of making, following up and settling claims or complaints where you can walk to the offices 
										of a local Insurance Company and speak to them in Swahili or English.</li>
								</ul>
							</PanelGroup>

							<PanelGroup title="What does the law say?">
								<p>Section 133 of the Amended Tanzania Insurance Act states that:</p>
								<ol className="numlist">
									<li>Insurance cover effected by a Tanzanian resident or a Tanzanian resident company of any 
										class or classes shall be placed with a Tanzanian insurer </li>
									<li>Where a class or classes of insurance required to be placed with a Tanzanian insurer in 
										terms of subsection (1) is or are not available to a person seeking insurance cover that 
										person may, through a resident insurer and with prior written approval of the Commissioner, 
										place that insurance cover with a non – Tanzanian insurer.</li>
									<li>For purposes of subsections (1) and (2), ground, marine and air cargo insurance covers for 
										Tanzanian imports shall be effected by a Tanzanian insurer.</li>
								</ol>
							</PanelGroup>

							<PanelGroup title="What is the penalty for non-compliance with the law?">
								<p>
									Although no specific penalties have been stipulated under the Tanzania Insurance Act with regards 
									to the procurement of Imports/Exports Insurance, Section 166 subsection 1 of the Act prescribes a 
									general penalty as follows: 
								</p>
								<p>
									<em>S.166 (1):  “Every person who acts in contravention of any of the provisions of this Act 
									commits an offense and shall, where no punishment has been stipulated by any other sections 
									of this Act for that offence, on conviction be liable to a fine not exceeding five million 
									shillings”. </em>
								</p>
							</PanelGroup>

							<PanelGroup title="What is the commencement date for implementation and enforcement of the law by the Tanzania Revenue Authority?">
								<p>The commencement date is 1st of January 2018</p>
							</PanelGroup>

							<PanelGroup title="How will the Tanzania Revenue Authority enforce the law?">
								<p>
									Customs officials will require submission of an Imports/Exports Insurance Certificate issued by 
									a Tanzanian-registered insurer before your goods can be cleared at customs.
								</p>
							</PanelGroup>

							<PanelGroup title="Is there a transition period?">
								<p>
									Yes. This will be communicated in the public domain by the relevant government authorities 
									in due course. The transition period ends on 31st December 2017. 
								</p>
							</PanelGroup>

							<PanelGroup title="What happens to pre-ordered Cargo?">
								<p>Cargo ordered before the effective date will not be affected by the new directive.</p>
							</PanelGroup>

							<PanelGroup title="Why should I opt-in for local marine cargo insurance when I have pre-negotiated rates with foreign insurers?">
								<p>
									First, Compliance with the laws of Tanzania is mandatory. 
								</p>
								<p>
									Second, it is not always true that pre-negotiated rates with foreign insurers are cheaper or 
									offer better cover than Tanzanian Imports/Exports insurance cover. This can be established by comparison. 
								</p>
								<p>
									Third, Tanzanian Imports/Exports insurance cover is normally Class A (Comprehensive), while normally 
									foreign marine cargo insurance cover either does not exist at all or is a lower, cheaper Class 
									because the foreign Seller naturally maximizes his profit. 
								</p>
							</PanelGroup>

							<PanelGroup title="How long does it take for local insurers to pay in the event of loss or damage to cargo?">
								<p>
									Settlement of claims for Marine Cargo Losses will be in line with settlement procedures as 
									established both by the law and by individual insurance company policies.
								</p>
							</PanelGroup>
							
							<PanelGroup title="Are there any exceptions or exemptions to the law?">
								<p>
									Yes. One can seek exemption from the Commissioner of Insurance. Also, personal effects 
									are exempted from Section 133 of The Tanzania Insurance Act. 
								</p>
							</PanelGroup>

							<PanelGroup title="What is the process of seeking exemption?">
								<p>By submitting a request to the Commissioner of Insurance.</p>
							</PanelGroup>

							<PanelGroup title="What is the scope of the cover?">
								<p>The scope of the cover depends on YOUR choice as an importer. </p>
								<p>
									Imports/Exports Insurance is subject to the Institute Cargo Clauses (ICC) A, B, & C, as well as 
									Inland Transit clauses, which cover risks during transportation over land. Cargo can be 
									covered from (1) Port to Port, (2) Door to Door, or (3) Warehouse to Warehouse, depending 
									on the choice of the importer.
								</p>
								<p>The Institute Cargo Clauses (ICC) are classified into 3 as follows:</p>

								<ul className="infolist">
									<li>
										ICC (A), which provides the maximum cover: It is the most comprehensive, widest cover, 
										covering all risks for partial or total loss of cargo from insured perils, loss or damage 
										or expense (including General Average and Salvage Charges Liabilities), except excluded 
										perils 4,5,6 & 7.
									</li>
									<li>
										However, with a payment of additional premium, cover for War & SRCC (Strike, Riots and Civil 
										Commotions) perils and perils of transhipments, storing cargo in warehouses and inland transport 
										may be obtained.
									</li>
									<li>
										ICC (B), which covers NAMED or LISTED MARINE PERILS, which are loss of or damage to the cargo 
										due to fire or explosion, vessel or craft being stranded, grounded, sunk or capsized, overturning 
										or derailment of land conveyance, collision of vessel with any external object, discharge of cargo 
										at a point of distress, earthquake, volcanic eruption or lightning and loss or damage to the cargo, 
										caused by general average sacrifice, jettisoning, Washing Overboard, Sea, Lake, River, Water damage 
										and Total Loss of package during loading/unloading.

										<p>
											<strong>In short, ICC (B) covers wider risks than ICC (C) but less than ICC (A).</strong>
										</p>
									</li>
									<li>
										ICC (C) covers the basic, minimum risk for partial loss of cargo caused by accidental damage to 
										the sea or land vessel as required by INCOTERMS 2010. Risks covered include loss or damage due to 
										Fire and Explosion, Stranding, Sinking, Capsizing, Overturning of a Lorry or train, collision, 
										discharge at a port of distress, total loss of vehicle, general average sacrifice and jettison.
										<br/><br/>
										However the importer is at liberty to negotiate for more covers which are not stipulated under 
										the ICC depending on the risks attached to the cargo.
										<br/><br/>
									</li>
									<li>
										What is NOT covered by any of the Institute Cargo Clauses:
										<ul className="infolist">
											<li>Wilful misconduct of the Assured, </li>
											<li>Ordinary leakage/loss in weight, </li>
											<li>Unsuitable packing,</li>
											<li>Inherent vice,</li>
											<li>Delay,</li>
											<li>Insolvency/financial default,</li>
											<li>Unseaworthiness of the vessel</li>
											<li>Vessel or container. </li>
										</ul>
									</li>
								</ul>
							</PanelGroup>
							
							<PanelGroup title="How many locally registered insurers offer Marine Insurance Cover?">
								<p>
									In Tanzania, there are 25 underwriters duly registered with The Tanzania Insurance Regulatory Authority (TIRA), 
									that currently offer Marine Cargo Insurance. 
								</p>
							</PanelGroup>
							
							<PanelGroup title="What goods, services or cargo must be insured?">
								<p>All types of imported/exported cargo must be insured, except for personal effects.</p>
							</PanelGroup>
							
							<PanelGroup title="What is the benefit of local insurance for Tanzania?">
								<ul className="infolist">
									<li>We build Tanzania</li>
									<li>We build Tanzania’s insurance industry, not foreign insurance industries</li>
									<li>
										We directly increase Tanzania’s insurance industry’s size and profitability, making 
										the industry stronger and better able to offer wider and greater insurance cover.
									</li>
									<li>We directly create jobs in the insurance industry</li>
									<li>
										We improve Tanzania’s insurance industry’s standards in customer service and claims 
										management and settlement necessitated by placing all marine cargo insurance locally
									</li>
									<li>
										We expand Tanzania’s tax revenue base significantly, enabling Government to provide more 
										and better services from a wider tax revenue base.
									</li>
								</ul>
							</PanelGroup>
						</Accordion>
					</Tab>
					<Tab menuId={ menuItems[3].id }>
						<Accordion className="col-md-9">
						<PanelGroup 
								title="What if I do not purchase Insurance from TIIP but another source overseas? Would the Customs let me clear my cargo? "
								show={ true }>
								<p>
									In accordance with the amended Insurance regulations effective 7th July 2017, 
									any purchase of Insurance (for Marine Imports into Tanzania) in contradiction to the amended law would be termed as a violation of the Insurance Act and would be punishable by law through penalties. 
								</p>
								<p>
									Marine Insurance (Ground, Air, Rail and/ or Sea for imports) has to be purchased from a Locally registered Tanzanian Insurance Company.
								</p>
							</PanelGroup>	
							<PanelGroup title="What if I don’t want to purchase any Insurance at all?">
								<p>
									The Tanzania Revenue Authority (TRA) as per the Customs Law and Regulations, 
									charge a levy of 1.5% on the value of the imported goods if a client imports goods without any Insurance at all
								</p>
								<p>
									When compared to the standard rates of Marine Insurance, 
									this is almost 3 to 4 times a Marine Insurance Policy rate and thus would not make commercial sense for a client to import without Marine Insurance.
								</p>
							</PanelGroup>	
							<PanelGroup title="Are Tanzanian Marine Insurance rates competitive?">
								<p>
									Marine Insurance is an International cover and thus most rates are set region wise, 
									in that respect Tanzania offers some of the best/ most competitive Marine Insurance rates
								</p>
								<p>
									In addition, all claims would be settled locally and The Tanzania Insurance Regulatory Authority (TIRA) plays a crucial part in ensuring clients are served with utmost efficiency incase of any dispute with Local Underwriters.
								</p>
							</PanelGroup>
						</Accordion>
					</Tab>
				</TabHolder>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/pages/FAQs.jsx